const UserTaxCertificateDestination = Object.freeze({
    CLIENT: 'CLIENT',
    ADVISER: 'ADVISER',
    ACCOUNTANT: 'ACCOUNTANT'
});

export default UserTaxCertificateDestination;
